import axios from "axios";

// Same-origin on custom domains so sign-in cookies stay first-party.
export const BACKEND_URL = window.location.hostname === "localhost" ? process.env.REACT_APP_BACKEND_URL : window.location.origin;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const setLedgerMode = (mode) => {
  if (mode === "sandbox") api.defaults.headers.common["X-Doorman-Ledger"] = "sandbox";
  else delete api.defaults.headers.common["X-Doorman-Ledger"];
};

export function errorText(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d?.msg || JSON.stringify(d)).replace(/^Value error, /, "")).join(" ");
  return detail.msg || String(detail);
}

export const short = (h, n = 10) => (h ? `${h.slice(0, n)}…${h.slice(-6)}` : "");

export const fmtTime = (iso) =>
  iso ? new Date(iso).toLocaleString(undefined, { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "—";

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
